export default __webpack_public_path__ + "static/media/avatar-jeong.735eeb62.jpg";